import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { MatomoService } from '@app/services/matomo.service';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { LanguageSwitchComponent } from '../language-switch/language-switch.component';

/**
 * application footer
 * holding required links to legal texts, etc.
 */
@Component( {
    selector: 'app-footer',
    imports: [ NgTemplateOutlet, LanguageSwitchComponent, MatExpansionModule, MatDividerModule, RouterLink ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    encapsulation: ViewEncapsulation.None
} )
export class FooterComponent implements OnInit {
    /** date, used to dynamically display year of copyright */
    readonly currentYear = new Date().getFullYear();

    showCookieConsent = environment.optionalModules.showCookieConsent;

    #matomoService = inject( MatomoService );

    /** default language of links */
    #lang = 'en';

    /** links in footer */
    linkImprint = '';
    linkTerms = '';
    linkTermsUS = '';

    /** ignore in coverage */
    authService = inject( AuthService );
    #cookieService = inject( CookieService );

    /**
     * on init check if languauge cookie is set
     * to set links in footer
     */
    ngOnInit() {
        this.setFooterLinks();
    }

    /** set legal links in footer depending on user language */
    setFooterLinks() {
        // show links to legal pages depending on language //
        const cookieExists: boolean = this.#cookieService.check( 'language' );

        if ( cookieExists ) {
            this.#lang = this.#cookieService.get( 'language' );
        } else {
            this.#lang = navigator.language;
        }

        switch ( this.#lang ) {
            case 'de':
            case 'de-DE':
            case 'de-AT':
            case 'de-CH':
                this.linkImprint = 'https://www.riege.com/de/impressum/';
                this.linkTerms = 'https://www.riege.com/de/agb/';
                this.linkTermsUS = 'https://www.riege.com/terms-us/';
                break;
            default:
                this.linkImprint = 'https://www.riege.com/imprint/';
                this.linkTerms = 'https://www.riege.com/terms/';
                this.linkTermsUS = 'https://www.riege.com/terms-us/';
        }
    }

    /**
     * helper function to show consent banner
     * @param event {object} click event
     */
    manageCookies( event: Event ) {
        event.preventDefault();
        this.#matomoService.handleTrackingConsent( true );
    }
}
